var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.908,
    height: 55.908,
    viewBox: "0 0 55.908 55.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3350",
    "data-name": "Group 3350",
    transform: "translate(15881.027 19072.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    transform: "matrix(0.951, -0.309, 0.309, 0.951, -15881.027, -19059.281)",
    fill: "none",
    stroke: "#fc5230",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: 17
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.185,
    cy: 22.185,
    r: 22.185,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.185,
    cy: 22.185,
    r: 20.685,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -15868.493, -19055.828)",
    fill: "#fff",
    stroke: "#fc5230",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.311,
    cy: 13.311,
    r: 13.311,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.311,
    cy: 13.311,
    r: 12.311,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCircle);
export default __webpack_public_path__ + "static/media/modal-circle.f4fb12cfed040c9ffe29bcb9990f0d3d.svg";
export { ForwardRef as ReactComponent };